import styled from 'styled-components';

type ChipProps = {
  title: string;
  isSelected?: boolean;
  onClick?: () => void;
};

export default function Chip({
  title,
  isSelected = false,
  onClick
}: ChipProps) {
  return (
    <Wrapper onClick={onClick} isSelected={isSelected}>
      {title}
    </Wrapper>
  );
}

export function GymLectureChip({
  title,
  isSelected = false,
  onClick
}: ChipProps) {
  return (
    <Wrapper2 onClick={onClick} isSelected={isSelected}>
      {title}
    </Wrapper2>
  );
}

// Chip 스타일 정의
const Wrapper2 = styled.div<{ isSelected: boolean }>`
  padding: 10px 20px;
  border-radius: 22px;
  border: ${({ isSelected, theme }) =>
    isSelected
      ? `2px solid ${theme.palette.brand400}`
      : `1px solid ${theme.palette.gray600}`};
  background-color: ${({ theme }) => theme.palette.gray800};
  font-weight: ${({ isSelected }) => (isSelected ? 600 : 400)};
  cursor: pointer;
  flex: 0 1 calc(33.33% - 16px); /* 한 줄에 3개씩 배치되도록 설정 */
  max-width: calc(33.33% - 16px); /* 간격을 고려하여 최대 너비 설정 */
  box-sizing: border-box; /* padding과 border를 너비 계산에 포함시킴 */
  margin-bottom: 8px; /* 칩 사이 간격 설정 */
  text-align: center; /* 텍스트 중앙 정렬 */
`;

const Wrapper = styled.div<{ isSelected: boolean }>`
  padding: 10px 20px;
  border-radius: 22px;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.palette.brand300 : theme.palette.gray25};
  border: ${({ isSelected, theme }) =>
    isSelected
      ? `2px solid ${theme.palette.brand400}`
      : `1px solid ${theme.palette.gray600}`};
  background-color: ${({ theme }) => theme.palette.gray800};
  font-weight: ${({ isSelected }) => (isSelected ? 600 : 400)};
  cursor: pointer;
`;
